import TabsController from '../components/info/TabsController';

export default function Info() {
	return <TabsController />;
}
